import { Injectable } from '@angular/core';

import { CommonService } from '@shared/services/common.service';
import { LoginPopupService } from '@shared/services/login-popup.service';
import { MetadataService, MetadataSlugs } from '@shared/services/metadata.service';

@Injectable({
  providedIn: 'root',
})
export class NoticeService {
  constructor(
    private metadataService: MetadataService,
    private commonService: CommonService,
    private loginPopupService: LoginPopupService
  ) {}

  showNoticeAfterLogin(): void {
    // Show the login notice (snackbar)
    this.metadataService.get<string>(MetadataSlugs.LoginNotice).subscribe({
      next: metadata => {
        if (metadata.value && metadata.value.trim() !== '') {
          this.commonService.openWarningSnackBar(metadata.value, 60000);
        }
        // Don't show anything if the value is empty or null
      },
      error: () => {
        // Don't show anything on error either
      },
    });

    // Show the login popup (modal dialog)
    setTimeout(() => {
      this.loginPopupService.showLoginPopup();
    }, 1000); // Small delay to avoid overwhelming the user
  }
}
